import PropTypes from 'prop-types';
import React from 'react';
import { NavLink } from 'fluxible-router';
import metrics from '../browser/metrics';

/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

const Breadcrumbs = ({ crumbs }) => (
  <ul
    className="breadcrumb"
    itemScope
    itemType="http://schema.org/BreadcrumbList"
  >
    {crumbs.map(crumb => (
      <li
        itemProp="itemListElement"
        itemScope
        itemType="http://schema.org/ListItem"
        key={crumb.title + crumb.url}
        onClick={() => metrics.track('click:breadcrumb', { title: crumb.title, url: crumb.url })}
      >
        <NavLink href={crumb.url} followLink={crumb.forceFullReload} activeClass="active">
          <span className="text" itemProp="name">{crumb.title}</span>
          <meta itemProp="position" content={crumbs.length + 1} />
        </NavLink>
      </li>
    ))}
  </ul>
);

Breadcrumbs.propTypes = {
  crumbs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      forceFullReload: PropTypes.bool
    }).isRequired
  ).isRequired
};

export default Breadcrumbs;
